import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  show: false,
  data: {
    id: 0,
    ticketNo: '',
    enforcer: '',
    startNo: '',
    endNo: ''
  }
}

const returnBookletSlice = createSlice({
  name: 'return_booklet',
  initialState,
  reducers: {
    openReturnModal: (state, { payload }) => {
      state.show = true;
      state.data = payload;
    },
    closeReturnModal: (state) => {
      state.show = false;
      state.data = { ...initialState.data };
    }
  }
})

export const { openReturnModal, closeReturnModal } = returnBookletSlice.actions;
export default returnBookletSlice.reducer
